//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { dialog } from 'src/boot/mixins.js';
export default {
  mixins: [dialog],
  props: {
    title: {
      type: String
    },
    icon: {
      type: String
    },
    withoutHeader: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    withoutFooter: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    withoutCloseBtn: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    persistent: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    padding: {
      type: String,
      default: 'md'
    },
    minWidth: {
      type: String,
      default: ''
    },
    maxWidth: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'standard'
    },
    dark: {
      type: Boolean,
      default: false
    },
    darkHeader: {
      type: Boolean,
      default: false
    },
    danger: {
      type: Boolean,
      default: false
    },
    warning: {
      type: Boolean,
      default: false
    },
    bodyClass: {
      type: String,
      default: ''
    },
    maximizable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      loading: false,
      loadingIcon: '',
      loadingMessage: ''
    };
  },
  computed: {
    cardStyle: function cardStyle() {
      var style = '';

      if (!this.isMobile) {
        if (this.width) {
          style += ' width:' + this.width + ';';
        }

        if (this.minWidth) {
          style += ' min-width:' + this.minWidth + ';';
        }

        if (this.maxWidth) {
          style += ' max-width:' + this.maxWidth + ';';
        }
      } else if (this.maximizable) {
        style = 'width: 100vw; height: calc(var(--vh, 1vh) * 100);';
      }

      return style;
    },
    bodyStyle: function bodyStyle() {
      if (!this.isMobile) {
        return 'max-height: calc(var(--vh, 1vh) * 100 - 250px)';
      } else {
        return ''; // return 'max-height: calc(var(--vh, 1vh) * 100 - ' + (this.withoutFooter ? 69 : 100) + 'px)'
      }
    }
  },
  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show: function show() {
      this.$refs.dialog.show();
    },
    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide: function hide() {
      this.$refs.dialog.hide();
    },
    onDialogHide: function onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$parent.$emit('hide');
    },
    showLoading: function showLoading(message) {
      var icon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.loading = true;
      this.loadingIcon = icon;
      this.loadingMessage = message;
    },
    hideLoading: function hideLoading() {
      this.loading = false;
      this.loadingIcon = '';
      this.loadingMessage = '';
    },
    onCancelClick: function onCancelClick() {
      // we just need to hide dialog
      this.hide();
    }
  }
};